import { Component, DestroyRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProviderService } from '@core/index';
import { MessageService } from 'primeng/api';
import { filter, switchMap, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ServiceProviderNote } from '@shared/model';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-new-provider-information',
  templateUrl: './add-new-provider-information.component.html',
  styleUrls: ['./add-new-provider-information.component.scss'],
  standalone: false
})
export class AddNewProviderInformationComponent implements OnInit {
  @Input() serviceProviderNote: ServiceProviderNote;

  @Output() serviceProviderNoteChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(
    private readonly providerService: ProviderService,
    private readonly messageService: MessageService,
    private readonly destroyRef: DestroyRef,
  ) { }

  get zipCode(): FormControl {
    return this.form.get('serviceProviderNote.address.zipCode') as FormControl;
  }

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = new FormGroup({
      serviceProviderNote: new FormGroup({
        npi: new FormControl(null, [Validators.required, Validators.minLength(10)]),
        providerName: new FormControl('', Validators.required),
        address: new FormGroup({
          zipCode: new FormControl('', [Validators.minLength(5), Validators.maxLength(5), Validators.pattern('^[0-9]+')]),
          state: new FormControl({value: '', disabled: true}),
          city: new FormControl('', [Validators.minLength(2), Validators.maxLength(50)]),
          addressLine1: new FormControl('', Validators.maxLength(100)),
          addressLine2: new FormControl('', Validators.maxLength(100)),
        }),
      })
    });
    
    this.formWatch();

    if (this.serviceProviderNote) {
      this.form.patchValue(this.serviceProviderNote);
      this.form.updateValueAndValidity();
    }
  }

  formWatch(): void {
    const stateControl = this.form.get('serviceProviderNote.address.state');

    this.zipCode.valueChanges.pipe(
      tap(() => stateControl.setValue('')),
      filter(() => this.zipCode.valid),
      switchMap(zipCode => this.providerService.getZipCodeCountyState(zipCode)),
      takeUntilDestroyed(this.destroyRef),
    ).subscribe(({ state, county, zipCode }) => {
      if (!zipCode) {
        this.messageService.add({
          severity: 'error',
          detail: `ZipCode ${this.zipCode.value} Not Found.`,
          life: 5000
        });
      } else {
        stateControl.setValue(state);
      }
      this.form.updateValueAndValidity();
    });

    this.form.valueChanges.subscribe(res => {
      this.serviceProviderNoteChange.emit({provider: res, isValid: this.form.valid})
    });
  }
}
